// extracted by mini-css-extract-plugin
export default {"progress":"style_progress__aS7M7","narrow":"style_narrow__jLYpg"};